var React = require('react');

function DoubleArrow (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("rect",{"fill":"none","height":"24","width":"24"})),React.createElement("g",{"key":1},React.createElement("g",null,[React.createElement("polygon",{"points":"18,6.41 16.59,5 12,9.58 7.41,5 6,6.41 12,12.41","key":0}),React.createElement("polygon",{"points":"18,13 16.59,11.59 12,16.17 7.41,11.59 6,13 12,19","key":1})]))]);
}

DoubleArrow.defaultProps = {"enableBackground":"new 0 0 24 24","height":"24px","viewBox":"0 0 24 24","width":"24px","fill":"#000000"};

module.exports = DoubleArrow;

DoubleArrow.default = DoubleArrow;
